<div [formGroup]="parts">

    <div *ngIf="isTextArea; else normal" >
        <textarea formControlName="textValue"  class="full-width"  (change)="changeData()" ></textarea>
    </div>
  <ng-template #normal>
    <input matInput formControlName="textValue"   class="full-width"    (change)="changeData()" >
  </ng-template>
  
  </div>
  
  